<div class="main">
  <router-outlet></router-outlet>
</div>
<ng-container *ngIf="error$ | async as error">
  <nz-modal (nzOnCancel)="isVisible = false" [(nzVisible)]="isVisible"
            [nzFooter]="null"
            nzTitle="An Error has Occurred!">
    <ng-container *nzModalContent>
      <p><strong>Error Code: </strong>{{error.code}}</p>
      <p><strong> Message: </strong>{{error.message}}</p>
    </ng-container>
  </nz-modal>
</ng-container>
